import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import * as React from 'react';
import { createSourceManager } from './createSourceManager';
export var SSEContext = React.createContext(null);
export var SSEConsumer = SSEContext.Consumer;

var isPropsWithSource = function isPropsWithSource(_) {
  return 'source' in _;
};

var createDefaultSource = function createDefaultSource(endpoint) {
  return function () {
    return new window.EventSource(endpoint);
  };
};

export var SSEProvider = function SSEProvider(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var _React$useState = React.useState(function () {
    return createSourceManager(!isPropsWithSource(props) ? createDefaultSource(props.endpoint) : props.source);
  }),
      _React$useState2 = _slicedToArray(_React$useState, 1),
      source = _React$useState2[0];

  return React.createElement(SSEContext.Provider, {
    value: source
  }, children);
};